/** Light watermark with the learner's Telegram id (screenshots stay traceable; spec §M6). */
export function Watermark({ id }: { id: number | null }) {
  if (!id) return null;
  const label = `ID ${String(id)}`;
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 z-50 flex flex-wrap content-start gap-x-16 gap-y-24 overflow-hidden p-6 opacity-[0.06] select-none"
    >
      {Array.from({ length: 40 }, (_, i) => (
        <span key={i} className="-rotate-[24deg] text-sm font-semibold whitespace-nowrap">
          {label}
        </span>
      ))}
    </div>
  );
}
